import React from "react";
import {Checkbox} from "evergreen-ui";
import {Controller, useFormContext, FieldError} from "react-hook-form";

type ModalCheckboxInputProps = {
    label: string;
    disabled: boolean;
    required?: boolean;
    name: string;
    validationRules?: any;
};

export function ModalCheckboxInput({
    label,
    disabled,
    required = false,
    name,
    validationRules,
}: ModalCheckboxInputProps) {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            rules={validationRules}
            render={({ field: { onChange, onBlur, value } }) => (
                <div className="w-full text-black-200 mt-2 text-base items-center bg-gray-100 p-2 rounded shadow-sm border border-gray-300">
                    <div className="flex items-center">
                        <Checkbox
                            checked={value || false}
                            onChange={(e) => onChange(e.target.checked)}
                            onBlur={onBlur}
                            disabled={disabled}
                            label={label}
                            required={required}
                        />
                    </div>
                    {errors[name] && (
                        <div className="text-red-700 text-xs ml-6">
                            {(errors[name] as FieldError)?.message}
                        </div>
                    )}
                </div>
            )}
        />
    );
}
